import { OrgSdk } from 'lib-klab-sdks';
import { ExecutableVersion } from '../../../domain/models/organization/executable-version.model';

export function mapSDKExecutableVersionToDomain(sdk: OrgSdk.ExecutableVersionResponse): ExecutableVersion {
    return {
        version: sdk.version ?? '',
        description: sdk.description,
        url: sdk.url ?? '',
        releaseDate: sdk.releaseDate ?? '',
    };
}
